import { z } from 'zod';
import { msg } from 'gt-react';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import {
  FeedbackDateBasisSchema,
  FeedbackKindSchema,
  FeedbackScopeSchema,
  FeedbackStatusSchema,
} from '@erp/rpc';
import {
  Route as pathlessAuthenticatedRoute,
  requireFeatureFlag,
} from '../route';

const FeedbackTriagePage = lazyRouteComponent(
  () => import('./FeedbackTriagePage'),
  'FeedbackTriagePage',
);

const searchSchema = z.object({
  page: z.number().int().min(1).optional(),
  pageSize: z.number().int().min(1).max(100).optional(),
  search: z.string().optional(),
  sortBy: z.string().optional(),
  sortDirection: z.enum(['asc', 'desc']).optional(),
  status: z.array(FeedbackStatusSchema).optional(),
  kind: z.array(FeedbackKindSchema).optional(),
  reporterUserIds: z.array(z.string()).optional(),
  userGroupIds: z.array(z.string()).optional(),
  ownerUserIds: z.array(z.string()).optional(),
  statsKind: z.union([FeedbackKindSchema, z.literal('all')]).optional(),
  scope: FeedbackScopeSchema.optional().catch(undefined),
  organizationId: z.string().optional(),
  /** Which timestamp the date window is on; absent = created. */
  dateBasis: FeedbackDateBasisSchema.optional().catch(undefined),
  // Inclusive `YYYY-MM-DD` bounds; a junk value is dropped, not a 400.
  dateFrom: z.iso.date().optional().catch(undefined),
  dateTo: z.iso.date().optional().catch(undefined),
  /** The item open in the detail sheet; also the notification deep link. */
  selected: z.string().optional(),
});

/**
 * Feedback: the triage dashboard for Feedback:Update holders, and a "follow
 * along" view of their own items for everyone else. Reached from the
 * top nav (`FeedbackNavLink`), the user menu, and the links on the
 * send-feedback panel and its sent toast, all open to every user, so there is
 * no sidebar entry. Behind the `feedback-triage-enabled` flag.
 */
export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/feedback-triage',
  component: FeedbackTriagePage,
  validateSearch: searchSchema,
  loader: () => ({
    crumb: msg('Feedback', { context: 'page breadcrumb' }),
  }),
  beforeLoad: () => {
    requireFeatureFlag('feedback-triage-enabled');
  },
});
